import { columnAt, geometryLine, rasterLine, toPt, type PageGeometry } from './model'

/**
 * The status strip. Every figure on it is measured, and none of it is
 * decoration: a reader who cannot say where on the page a passage sits cannot
 * cite it.
 */

export function StatusBar({
  geometry,
  pointer,
  regionCount,
  selectedCount,
  onKeys,
}: {
  geometry: PageGeometry
  pointer: { x: number; y: number } | null
  regionCount: number
  selectedCount: number
  onKeys?: () => void
}) {
  const column = pointer ? columnAt(pointer.x, geometry) : null
  return (
    <div className="statusbar">
      <div className="text-ink">
        {pointer
          ? `x ${Math.round(pointer.x)}  y ${Math.round(pointer.y)} px`
          : 'x -  y - px'}
      </div>
      <div>
        {pointer
          ? `= ${toPt(pointer.x, geometry.ppi).toFixed(1)}, ${toPt(pointer.y, geometry.ppi).toFixed(1)} pt`
          : '= -, - pt'}
      </div>
      <div className="text-rule2">|</div>
      <div>{column ? `col ${column} of ${geometry.columnCount}` : 'col -'}</div>
      <div className="text-rule2">|</div>
      <div>
        {regionCount} regions · {selectedCount} selected
      </div>
      <div className="ml-auto whitespace-nowrap">{geometryLine(geometry)}</div>
      <div className="text-rule2">|</div>
      <div className="whitespace-nowrap">{rasterLine(geometry)}</div>
      <div className="text-rule2">|</div>
      <div className="whitespace-nowrap">
        route {geometry.route ?? '-'} · {geometry.engine ?? '-'}
      </div>
      {onKeys && (
        <>
          <div className="text-rule2">|</div>
          <button
            type="button"
            className="whitespace-nowrap text-accent"
            onClick={onKeys}
            title="The keyboard path"
          >
            KEYS ?
          </button>
        </>
      )}
    </div>
  )
}
